// Catálogo dos documentos legais publicados neste site.
// Os arquivos .md vivem em public/legal/<slug>/<arquivo>.md e são as fontes
// canônicas copiadas de cada projeto (PT e EN).
export const DOC_KEYS = ['privacidade', 'termos'];

// Nome do arquivo .md por tipo de doc e idioma.
const FILE_MAP = {
  privacidade: { pt: 'privacidade.md', en: 'privacy.md' },
  termos: { pt: 'termos.md', en: 'terms.md' },
};

export const LEGAL_PROJECTS = [
  { slug: 'termo', name: 'Termo!', emoji: '🎮' },
  { slug: 'lume', name: 'Lume', emoji: '🌱' },
  { slug: 'julius', name: 'Julius', emoji: '💸' },
  { slug: 'whodoku', name: 'Whodoku', emoji: '🔎' },
];

export const getProject = (slug) => LEGAL_PROJECTS.find((p) => p.slug === slug);

export const isValidDoc = (doc) => DOC_KEYS.includes(doc);

export const getDocFile = (slug, doc, lang) => {
  const file = FILE_MAP[doc]?.[lang === 'en' ? 'en' : 'pt'];
  return file ? `${slug}/${file}` : null;
};
